import React, { useEffect } from "react";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import Text from "@components/Text";
import { themeDefault } from "src/theme-revamp";
import video from "@assets/videos/shield_starter_value_story_animation.mp4";

function VideoModal() {
  return (
    <Container>
      <FormHeaderContainer>
        <Text align={"center"} theme={themeDefault} className={HeaderTitleCss}>
          Find out how Singlife Shield Starter
        </Text>
        <Text align={"center"} theme={themeDefault} className={HeaderTitleCss}>
          and Health Plus Starter helped Andy
        </Text>
      </FormHeaderContainer>
      <FormContentContainer>
        <video autoPlay loop src={video} className={VideoPlayerCss} />
      </FormContentContainer>
    </Container>
  );
}

export default VideoModal;

const VideoPlayerCss = css`
  width: auto;
  height: 400px;
  border-radius: 24px;
  @media screen and (max-width: 768px) {
    height: 200px;
    border-radius: 16px;
  }
`;

const Container = styled.div``;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: #883e89;
  font-size: 18px;
  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 48px;
`;

const FormContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
